<ng-container
  *appLet="{
    doesPnrExist: doesPnrExist$ | async,
    isFlightsPage: isFlightsPage$ | async,
    isHomePage: isHomePage$ | async,
    isModifyPath: isModifyPath$ | async,
    stations: stations$ | async,
    stationsWithConnections: stationsWithConnections$ | async,
    norseStations: norseStations$ | async,
    dohopStations: dohopStations$ | async,
    culture: culture$ | async,
    lastSearchedCriteria: lastSearchedCriteria$ | async,
    selectedCurrencyCode: selectedCurrencyCode$ | async,
    geolocatedCountryCode: geolocatedCountryCode$ | async,
    isModifyWidget: isModifyWidget$ | async,
    passengers: passengers$ | async,
    featIsOnUS273: gbs.isOn(gbf.FEAT_US273_PREVIOUS_SEARCHES_AVAILABLE_ON_FRONTPAGE),
    featStringValueUS273: gbs.getFeatureStringValue(gbf.FEAT_US273_PREVIOUS_SEARCHES_AVAILABLE_ON_FRONTPAGE),
    featIsOnUS505: gbs.growthBook.isOn(gbf.FEAT_US505_BGCOLOR_CTA_FRONTPAGE_SEARCH),
    featStringValueUS505: gbs.growthBook.getFeatureValue(gbf.FEAT_US505_BGCOLOR_CTA_FRONTPAGE_SEARCH, ''),
    featIsOnUS572: gbs.growthBook.isOn(gbf.FEAT_US572_PROMOCODE_FRONT_CAMPAIGNS),
    featStringValueUS572: gbs.getFeatureStringValue(gbf.FEAT_US572_PROMOCODE_FRONT_CAMPAIGNS, ''),
    featIsOnUS498: gbs.growthBook.isOn(gbf.FEAT_498_REMOVE_CTA_SEARCH_FRONTPAGE),
    featStringValueUS498: gbs.growthBook.getFeatureValue(gbf.FEAT_498_REMOVE_CTA_SEARCH_FRONTPAGE, ''),
    featStringValueUS1416US: gbs.growthBook.getFeatureValue('feat-001416-change-search-area-to-media-content-US', ''),
    featStringValueUS1416ROW: gbs.growthBook.getFeatureValue('feat-001416-change-search-area-to-media-content-ROW', ''),
    featStringValueUS1611: gbs.growthBook.getFeatureValue('feat-001611-commercial-bubble-frontpage', ''),
    autoSearch: autoSearch$ | async,
    searchInput: searchInput$ | async,
  } as $comp"
>
  <div class="container">
    <div class="d-flex justify-content-center">
      <div
        class="search-widget-container mx-3 mx-sm-0"
        [class.search-widget-container--background]="background"
        [class.py-3]="!background"
        [ngClass]="{'search-widget-container--with-margin': !!$comp.isHomePage}"
        *appLet="
          ($comp.isFlightsPage ?? false) &&
          ($comp.doesPnrExist ?? false) as isStationPickerDisabled
        "
      >

        @if ($comp.isHomePage && $comp.featStringValueUS1611 === 'b' && ($comp.featStringValueUS1416US !== 'a' || $comp.featStringValueUS1416ROW !== 'a') && !!appCopy && !!appCopy.searchWidgetFull) {
          <div class="search-widget__bubble">
            <div class="search-widget__bubble-title">{{ appCopy.searchWidgetFull.searchBubbleTitle }}</div>
            <p class="search-widget__bubble-copy">{{ appCopy.searchWidgetFull.searchBubbleCopy }}<a
              [routerLink]="['/experience', 'where-we-fly']">{{ appCopy.searchWidgetFull.searchBubbleLink }}</a>
              {{ appCopy.searchWidgetFull.searchBubbleCopy2 }}
            </p>
          </div>
        }

        <div
          *ngIf="!$comp.isModifyWidget"
          class="search-widget-container__title fs-1 fw-medium text-white"
        >
          @if (
            ['en-US', 'en-GB'].includes($comp.culture || FALLBACK_CULTURE)
          ) {
            <span>Where can we take you?</span>
          } @else {
            <span>{{ cmsCopy.whereToExplorer }}</span>
          }
        </div>
        <div
          *ngIf="$comp.isModifyWidget"
          class="my-1 mb-4 fs-1 fw-medium text-white text-center"
        >
          <span>{{ cmsCopy.modifySearch }}</span>
        </div>
        <div class="col">
          <form
            *ngIf="searchWidgetForm"
            [formGroup]="searchWidgetForm"
            (ngSubmit)="
              onSubmit(
                $comp.selectedCurrencyCode,
                $comp.culture ?? FALLBACK_CULTURE,
                $comp.lastSearchedCriteria ?? undefined,
                $comp.geolocatedCountryCode ?? undefined,
                undefined,
                $comp.isModifyPath ?? false
              )
            "
          >
            @if (!isMulticityPage) {
              <div class="chips justify-content-between">
                <div>
                    <app-trip-type-picker
                      [formGroup]="tripTypePromoCntl"
                      [cmsSearchWidgetCopy]="cmsCopy"
                    >
                    </app-trip-type-picker>

                  <!-- @if (!isFlightsPage) {
                    @if($comp.featIsOnUS372 && $comp.featStringValueUS372 === 'b') {
                      <app-travelers-chip
                        [culture]="$comp.culture ?? FALLBACK_CULTURE"
                        (onClick)="onTravelersChipClick()">
                      </app-travelers-chip>
                    }
                  } -->
                </div>
                <div class="placeholder-float-left center-label float-label-white"
                  [ngClass]="{'visually-hidden': !showPromoInput(cmsCopy.promoInputShow)}">
                  <app-input
                    [formGroup]="tripTypePromoCntl"
                    [label]="cmsCopy.promoCode"
                  >
                  <input
                  appInput
                  type="text"
                  name="promoCode"
                  data-qa="promoCode"
                  formControlName="promoCode"
                  class="form-control promo-input"
                  maxlength="8"
                  [placeholder]="cmsCopy.promoCode"
                />
                  </app-input>
                </div>
              </div>
            }
            <div
              class="col"
              *ngFor="
                let ctrl of stationsCtrl.controls;
                let i = index;
                let isLast = last
              "
            >
              @if (isMulticityPage || $comp.isFlightsPage && tripType === TripType.multiCity) {
                <div [ngClass]="{ 'mt-2': i !== 0 }">
                  {{ cmsCopy.flight + ' ' + (i + 1).toString() }}
                </div>
              }
              <div class="mt-2">
                <div class="stations-container">
                  <app-station-picker
                    [isDisabled]="isStationPickerDisabled"
                    [formGroup]="getStationsCtrl(i)"
                    [index]="i"
                    [stations]="activeStations"
                    [culture]="$comp.culture ?? FALLBACK_CULTURE"
                    [tripType]="tripTypeCntl.value"
                    [norseStations]="$comp.norseStations"
                    [dohopFeatureStations]="$comp.dohopStations"
                    (originStationChange)="onOriginStationChange($event, i)"
                    (destinationStationChange)="
                      onDestinationStationChange($event, i)
                    "
                    (keydown.enter)="$event.preventDefault()"
                    [copy]="cmsCopy"
                    [stationsForceMacCode]="cmsCopy.stationsForceMacCode"
                    [isDateRangePickerEnabled]="isDateRangePickerEnabled"
                  ></app-station-picker>
                </div>
                @if (
                  $comp.isHomePage &&
                  isValidStationCtrl(i) &&
                  isDateRangePickerEnabled
                ) {
                  <app-date-range-picker
                    [desktopFirstDatePlaceholder]="cmsCopy.departDate"
                    [desktopSecondDatePlaceholder]="cmsCopy.returnDate"
                    [mobileConfirmButtonText]="appCopy.confirm"
                    [mobileDatePlaceholder]="appCopy.whereAreYouFlying"
                    [mobileHeaderTitle]="appCopy.whereAreYouFlying"
                    [mobileSkipButtonText]="appCopy.imFlexible"
                    [skipText]="appCopy.imFlexible"
                    [noSkipText]="appCopy.exactDates"
                    [withSkip]="true"
                    [isSingleDate]="isDatePickerSingleDate"
                    [disabledFirstDateRange]="getDisabledDatesForDepartDate(i)"
                    [disabledSecondDateRange]="getDisabledDatesForReturnDate(i)"
                    [startDate]="getFirstDateForDateRangePicker(i)"
                    [endDate]="getLastDateForDateRangePicker(i)"
                    (dateChanges)="onDateRangePickerChanges(i, $event)"
                  ></app-date-range-picker>
                }
                <div class="dates-picker-container visually-hidden">
                  <app-dates-picker
                    [formGroup]="getDatesCtrl(i)"
                    [tripType]="tripTypeCntl.value"
                    [minDate]="minDates[i] ?? DEFAULT_MIN_DATE"
                    [maxDate]="scheduleLoadedThruDateAsDate ?? DEFAULT_MAX_DATE"
                    [departDates]="departDates[i]"
                    [returnDates]="returnDates"
                    [departDateClasses]="departDateClasses[i]"
                    [returnDateClasses]="returnDateClasses"
                    [group]="i"
                    [cmsEntries]="{
                      departDate: cmsCopy.departDate,
                      returnDate: cmsCopy.returnDate
                    }"
                    (departDateChange)="onDepartDateChange(i)"
                  ></app-dates-picker>
                </div>
              </div>
              <div *ngIf="isFlightsPage && isLast" class="pax-picker mt-2">
                <app-traveler-picker
                  class="col-auto"
                  formGroupName="travelers"
                  [isDisabled]="isStationPickerDisabled"
                  [cmsSearchWidgetCopy]="cmsCopy"
                >
                </app-traveler-picker>
              </div>
            </div>
              @if (!checkIfRemoveCtaButtonFeatureIsOn($comp.autoSearch?.search ?? false, $comp.searchInput)) {
                <div class="mt-2">
                  <button
                    type="submit"
                    class="btn btn-primary btn-cta w-100 fw-medium"
                    [ngClass]="{
                    'btn-cta--variant-b': $comp.featIsOnUS505 && $comp.featStringValueUS505 === 'b',
                    'btn-cta--variant-c': $comp.featIsOnUS505 && $comp.featStringValueUS505 === 'c',
                    'btn-cta--variant-d': $comp.featIsOnUS505 && $comp.featStringValueUS505 === 'd',
                    'btn-cta--variant-e': $comp.featIsOnUS505 && $comp.featStringValueUS505 === 'e',
                  }"
                    data-qa="search-widget-button"
                  >
                    {{ cmsCopy.showFlights }}
                  </button>
                </div>
              }
              <div class="mt-2" *ngIf="isFlightsPage">
                <button
                  type="button"
                  class="btn btn-text-primary w-100 fw-medium"
                  (click)="onCancel()"
                >
                  {{ cmsCopy.cancel }}
                </button>
              </div>
          </form>
        </div>
        <app-previous-search
          [stations]="stations"
          (lastSearchClicked)="lastSearchClicked = $event">
        </app-previous-search>
      </div>
    </div>
  </div>
</ng-container>
